(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductCategoryDeleteController',ProductCategoryDeleteController);

    ProductCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProductCategory'];

    function ProductCategoryDeleteController($uibModalInstance, entity, ProductCategory) {
        var vm = this;
        vm.productCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ProductCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
